<div class="d-flex flex-row button-container align-items-center">
    @if (!showConfirmation) {
        <eff-icon
            [icon]="icon"
            class="action-icon"
            (click)="$event.stopPropagation(); onClick()"
        ></eff-icon>
    }
    <div #confirmationButton>
        @if (showConfirmation) {
            <eff-button
                [text]="label"
                [icon]="icon"
                iconPosition="right"
                (onClick)="onConfirmationClick()"
            ></eff-button>
        }
    </div>
</div>
